/**
 * calz.ts — Categoría "Calzado" (10 productos demo).
 */
import { buildProduct } from "./_factory";
import type { Producto } from "@/types";

const CAT = {
  categoryId: "cat_calz",
  skuPrefix: "CAL",
  categoria: "Calzado",
} as const;

export const cat_calz_products: Producto[] = [
  buildProduct({
    ...CAT,
    index: 0,
    nombre: "Tenis Nike Air Max",
    marca: "Nike",
    modelo: "Air Max 270",
    origen: "Vietnam",
    costo: 285000,
    precio: 449000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "par",
    ubicacionFisica: "Estante C1, deportivo",
    proveedor: "Nike Colombia",
    material: "Mesh, sintético y caucho",
    colorProducto: "Negro/blanco",
    talla: "42",
    descripcionLarga:
      "Tenis lifestyle Air Max 270 con máxima amortiguación en talón. Upper mesh transpirable. Icono urbano.",
    especificaciones: [
      { clave: "Amortiguación", valor: "Air Max 270" },
      { clave: "Uso", valor: "Lifestyle" },
    ],
    imageKeywords: ["nike-airmax", "sneakers", "running-shoes"],
    color: "bg-slate-900",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 1,
    nombre: "Tenis Adidas Originals Stan Smith",
    marca: "Adidas",
    modelo: "Stan Smith",
    origen: "Vietnam",
    costo: 195000,
    precio: 309000,
    stock: 30,
    stockMinimo: 8,
    stockMaximo: 60,
    unidad: "par",
    ubicacionFisica: "Estante C1",
    proveedor: "Adidas Colombia",
    material: "Cuero sintético",
    colorProducto: "Blanco/verde",
    talla: "41",
    descripcionLarga:
      "Icono atemporal Stan Smith con upper de cuero sintético y detalles verdes. Estilo minimalista para cualquier ocasión.",
    especificaciones: [
      { clave: "Estilo", valor: "Lifestyle" },
      { clave: "Color", valor: "Blanco/verde" },
    ],
    imageKeywords: ["stan-smith", "adidas-originals", "white-sneakers"],
    color: "bg-white",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 2,
    nombre: "Botas Trekking Hombre",
    marca: "Columbia",
    modelo: "Newton Ridge",
    origen: "Vietnam",
    costo: 225000,
    precio: 349000,
    stock: 18,
    stockMinimo: 5,
    stockMaximo: 36,
    unidad: "par",
    ubicacionFisica: "Estante C2, outdoor",
    proveedor: "Columbia Sportswear",
    garantia: "1 año",
    material: "Cuero y mesh",
    colorProducto: "Marrón",
    talla: "42",
    descripcionLarga:
      "Bota de senderismo impermeable con tecnología Omni-Grip. Caña media para soporte de tobillo. Ideal para montaña.",
    especificaciones: [
      { clave: "Impermeable", valor: "Sí" },
      { clave: "Suela", valor: "Omni-Grip" },
    ],
    imageKeywords: ["hiking-boots", "trekking-shoes", "mountain-boots"],
    color: "bg-amber-800",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 3,
    nombre: "Zapato Formal Hombre Cuero",
    marca: "Vélez",
    modelo: "Oxford Clásico",
    origen: "Colombia",
    costo: 185000,
    precio: 289000,
    stock: 22,
    stockMinimo: 6,
    stockMaximo: 44,
    unidad: "par",
    ubicacionFisica: "Estante C3, formal",
    proveedor: "Vélez",
    material: "Cuero vacuno genuino",
    colorProducto: "Café",
    talla: "42",
    descripcionLarga:
      "Zapato Oxford de cuero genuino, cosido Goodyear. Elegante y duradero para ocasiones formales.",
    especificaciones: [
      { clave: "Material", valor: "Cuero vacuno" },
      { clave: "Construcción", valor: "Goodyear welt" },
    ],
    imageKeywords: ["oxford-shoes", "leather-shoes", "formal-shoes"],
    color: "bg-amber-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 4,
    nombre: "Tacón Mujer Cerrado 8cm",
    marca: "Vélez",
    modelo: "Stiletto Classic",
    origen: "Colombia",
    costo: 125000,
    precio: 198000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "par",
    ubicacionFisica: "Estante C3",
    proveedor: "Vélez",
    material: "Cuero sintético",
    colorProducto: "Negro",
    talla: "36",
    descripcionLarga:
      "Zapato de tacón cerrado 8cm, punta almendrada. Plantilla acolchada para mayor comodidad. Versátil.",
    especificaciones: [
      { clave: "Altura tacón", valor: "8cm" },
      { clave: "Forma", valor: "Stiletto" },
    ],
    imageKeywords: ["high-heels", "black-heels", "womens-pumps"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 5,
    nombre: "Sandalia Mujer Verano",
    marca: "Havaianas",
    modelo: "Top Mix",
    origen: "Brasil",
    costo: 45000,
    precio: 69900,
    stock: 45,
    stockMinimo: 10,
    stockMaximo: 90,
    unidad: "par",
    ubicacionFisica: "Estante C4, casual",
    proveedor: "Havaianas Colombia",
    material: "Caucho natural",
    colorProducto: "Coral",
    talla: "37",
    descripcionLarga:
      "Chancla Havaianas clásica en caucho, estampado textura arroz. Cómodas y duraderas para el día a día.",
    especificaciones: [
      { clave: "Material", valor: "Caucho" },
      { clave: "Estilo", valor: "Flip flop" },
    ],
    imageKeywords: ["flip-flops", "havaianas", "summer-sandals"],
    color: "bg-orange-500",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 6,
    nombre: "Tenis Running Mujer",
    marca: "Asics",
    modelo: "Gel-Kayano 29",
    origen: "Vietnam",
    costo: 325000,
    precio: 499000,
    stock: 20,
    stockMinimo: 5,
    stockMaximo: 40,
    unidad: "par",
    ubicacionFisica: "Estante C1",
    proveedor: "Asics Colombia",
    garantia: "6 meses",
    material: "Mesh transpirable",
    colorProducto: "Rosa/gris",
    talla: "37",
    descripcionLarga:
      "Running shoes premium con tecnología Gel y Dynamic DuoMax para pronadores. Máximo soporte y amortiguación.",
    especificaciones: [
      { clave: "Tipo", valor: "Pronador" },
      { clave: "Drop", valor: "10mm" },
    ],
    imageKeywords: ["running-shoes", "asics-kayano", "womens-running"],
    color: "bg-pink-400",
    shape: "square",
    gastoMargen: "estandar",
  }),
  buildProduct({
    ...CAT,
    index: 7,
    nombre: "Botines Mujer Tacón Bajo",
    marca: "Bosi",
    modelo: "Ankle Boot",
    origen: "Colombia",
    costo: 145000,
    precio: 229000,
    stock: 25,
    stockMinimo: 6,
    stockMaximo: 50,
    unidad: "par",
    ubicacionFisica: "Estante C5",
    proveedor: "Bosi S.A.",
    material: "Cuero sintético",
    colorProducto: "Negro",
    talla: "37",
    descripcionLarga:
      "Botón mujer tobillero con tacón de bloque 5cm. Cierre lateral, punta redonda. Versátil otoño-invierno.",
    especificaciones: [
      { clave: "Altura tacón", valor: "5cm" },
      { clave: "Cierre", valor: "Cremallera lateral" },
    ],
    imageKeywords: ["ankle-boots", "womens-boots", "black-boots"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 8,
    nombre: "Zapato Niño Escolar",
    marca: "Bubblegummers",
    modelo: "School Classic",
    origen: "Colombia",
    costo: 65000,
    precio: 99900,
    stock: 40,
    stockMinimo: 10,
    stockMaximo: 80,
    unidad: "par",
    ubicacionFisica: "Estante C6, infantil",
    proveedor: "Bata Colombia",
    material: "Cuero sintético",
    colorProducto: "Negro",
    talla: "32",
    descripcionLarga:
      "Zapato colegial para niño con cierre velcro, plantilla anatómica y suela antideslizante.",
    especificaciones: [
      { clave: "Cierre", valor: "Velcro" },
      { clave: "Uso", valor: "Escolar" },
    ],
    imageKeywords: ["kids-shoes", "school-shoes", "boys-shoes"],
    color: "bg-slate-900",
    shape: "square",
  }),
  buildProduct({
    ...CAT,
    index: 9,
    nombre: "Pantuflas Casa Invierno",
    marca: "Dearfoams",
    origen: "China",
    costo: 28500,
    precio: 44900,
    stock: 50,
    stockMinimo: 12,
    stockMaximo: 100,
    unidad: "par",
    ubicacionFisica: "Estante C7",
    proveedor: "Importaciones Hogar",
    material: "Felpa y memory foam",
    colorProducto: "Gris",
    talla: "38",
    descripcionLarga:
      "Pantuflas abrigadas con interior de felpa y plantilla memory foam. Suela antideslizante para el hogar.",
    especificaciones: [
      { clave: "Material", valor: "Felpa" },
      { clave: "Plantilla", valor: "Memory foam" },
    ],
    imageKeywords: ["slippers", "home-slippers", "warm-slippers"],
    color: "bg-slate-400",
    shape: "square",
  }),
];
